module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('draggable', {
    attrs: {
      "options": {
        draggable: '.item',
        disabled: !_vm.isEdit
      }
    },
    model: {
      value: (_vm.itemList),
      callback: function($$v) {
        _vm.itemList = $$v
      },
      expression: "itemList"
    }
  }, [_vm._l((_vm.itemList), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "item",
      class: {
        last: key == _vm.itemList.length - 1 && (key + 1) % 4 != 0 && !_vm.isShow, first: key % 4 == 0, active: _vm.isEdit
      },
      on: {
        "click": function($event) {
          return _vm.linkurl(item)
        }
      }
    }, [_c('p', [_c('i', {
      staticClass: "iconfont",
      class: item.pic,
      style: ({
        color: item.color
      })
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isEdit),
        expression: "isEdit"
      }],
      staticClass: "edit",
      on: {
        "click": function($event) {
          return _vm.deleteItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-iconless"
    })]), _vm._v(" "), (item.tip) ? _c('div', {
      staticClass: "beta"
    }, [_c('i', {
      staticClass: "iconfont",
      class: 'icon-' + item.tip
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "item",
    class: {
      last: (_vm.itemList.length + 1) % 4 != 0
    },
    on: {
      "click": _vm.goMoreFunction
    }
  }, [_c('p', [_c('i', {
    staticClass: "iconfont icon-menu"
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('more')))])]) : _vm._e()], 2), _vm._v(" "), (!_vm.isShow) ? _c('div', {
    staticClass: "normalFns"
  }, _vm._l((_vm.myFuncitons), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "normalFn"
    }, [(item.funtions && (item.funtions.length > 0)) ? _c('h1', [_c('i', {
      staticClass: "iconfont icon-changfangxingbiaoqian"
    }), _vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), _vm._l((item.funtions), function(funtion, key) {
      return _c('div', {
        key: key,
        staticClass: "item",
        class: {
          last: key == item.funtions.length - 1 && (key + 1) % 4 != 0, first: key % 4 == 0, active: _vm.isEdit
        },
        on: {
          "click": function($event) {
            return _vm.linkurl(funtion)
          }
        }
      }, [_c('p', [_c('i', {
        staticClass: "iconfont",
        class: funtion.pic,
        style: ({
          color: funtion.color
        })
      })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(funtion.title) + _vm._s(item.url))]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.isEdit),
          expression: "isEdit"
        }],
        staticClass: "edit add",
        class: {
          gray: funtion.favorite
        },
        on: {
          "click": function($event) {
            return _vm.addItem(funtion)
          }
        }
      }, [_c('span', {
        class: {
          right: funtion.favorite
        }
      }, [(funtion.favorite) ? _c('i', {
        staticClass: "iconfont icon-right"
      }) : _c('i', {
        staticClass: "iconfont icon-jiahao"
      })])]), _vm._v(" "), (funtion.tip) ? _c('div', {
        staticClass: "beta"
      }, [_c('i', {
        staticClass: "iconfont",
        class: 'icon-' + funtion.tip
      })]) : _vm._e()])
    })], 2)
  }), 0) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3cb080a9","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/myList.vue
// module id = 1775
// module chunks = 107